import { useLocation } from "react-router-dom";

export default function useQueryParams<T extends string[]>(
  keys: [...T]
): Record<T[number], string | null> {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  return Object.fromEntries(
    keys.map((key) => [key, searchParams.get(key)])
  ) as Record<T[number], string | null>;
}
